import { Component } from '@angular/core';
import { UilabMatCheckboxModule } from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface CheckboxExample {
    readonly variant: 'default' | 'indeterminate';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
    readonly previewLabel: string;
    readonly checked: boolean;
    readonly disabled: boolean;
    readonly indeterminate: boolean;
}

@Component({
    selector: 'avd-checkbox-examples',
    templateUrl: './checkbox-examples.component.html',
    styleUrls: ['./checkbox-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatCheckboxModule,
    ],
})
export class CheckboxExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink =
        'https://calm-mushroom-0d2458d1e.2.azurestaticapps.net/?path=/docs/components-form-controls-checkbox--docs';
    readonly repoLink =
        'https://dev.azure.com/AVEVA-VSTS/UX/_git/uilab-base?version=GBfeat/angular-material-components&path=/projects/components/src/lib/checkbox';

    readonly examples: readonly CheckboxExample[] = [
        {
            variant: 'default',
            label: 'Default Checkbox',
            description:
                'Use a checkbox when users can make one or more independent selections.',
            htmlSnippet: '<uilab-mat-checkbox>Checkbox</uilab-mat-checkbox>',
            previewLabel: 'Checkbox',
            checked: false,
            disabled: false,
            indeterminate: false,
        },
        {
            variant: 'indeterminate',
            label: 'Indeterminate Checkbox',
            description:
                'Use indeterminate to represent a partial selection state in grouped choices.',
            htmlSnippet:
                '<uilab-mat-checkbox [indeterminate]="true">Checkbox</uilab-mat-checkbox>',
            previewLabel: 'Checkbox',
            checked: false,
            disabled: false,
            indeterminate: true,
        },
    ];
}
